import authReducer          from './reducers/authReducer';
import gateReducer          from './reducers/gateReducer';
import userReducer          from './reducers/userReducer';
import guestReducer         from './reducers/guestReducer.js';
import { combineReducers }  from 'redux';
import { firebaseReducer as firebase } from 'react-redux-firebase';
import { reducer as form }  from 'redux-form';
import { firestoreReducer } from 'redux-firestore';

const rootReducer = combineReducers({
    auth:       authReducer,
    firebase:   firebase,
    firestore:  firestoreReducer,
    form:       form,
    gate:       gateReducer,
    user:       userReducer,
    guest:      guestReducer,
});
  
export default rootReducer
  